<template>
  <div class="page-wrap">
    <div class="page-head">
      <h1>{{ $vuetify.lang.t('$vuetify.menu.Vacancies') }}</h1>

    </div>

    <div class="page-head page-head--sorts">
      <div class="page__sorts">
        <v-text-field class="search-field" v-model="search" @keypress.enter="page=1; loadData()"
                      @keypress.tab="page=1; loadData()" enterkeyhint="search"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.search')" outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>

        <address-autocomplete :label="$vuetify.lang.t('$vuetify.address')"
                              @input="inputCoordinates" @clear="clearCoordinates"></address-autocomplete>
        <v-text-field v-model.number="radius" type="number" :label="$vuetify.lang.t('$vuetify.cvs.radius')"
                      outlined hide-details></v-text-field>
        <button class="btn-action btn-icon" @click="loadData">
          <search-icon></search-icon>
        </button>
      </div>
    </div>

    <vacancy-list :vacancies="vacancies" :responded="responded" :show-edit="false" @openRespond="openRespond"></vacancy-list>

    <MakeOfferToCompanyModal v-model="makeOfferModal" :vacancy_id="offer_vacancy_id"></MakeOfferToCompanyModal>

  </div>
</template>

<script>
import VacancyList from "@/components/VacancyList.vue";
import MakeOfferToCompanyModal from "@/components/MakeOfferToCompanyModal.vue";
import AddressAutocomplete from "@/components/AddressAutocomplete.vue";
import SearchIcon from "@/components/icons/SearchIcon.vue";

export default {
  name: "my-vacancies",
  components: {SearchIcon, AddressAutocomplete, VacancyList, MakeOfferToCompanyModal},

  data: function () {
    return {
      loader: false,
      form_loader: false,
      alertMsg: "",
      alertError: false,

      search: '',
      vacancies: [],
      responded: [],

      radius: null,
      latitude: null,
      longitude: null,

      offer_vacancy_id: null,
      makeOfferModal: false
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    openRespond(vacancy) {
      this.offer_vacancy_id = vacancy.id
      this.makeOfferModal = true
    },

    loadData() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/vacancies",
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          search: this.search,
          page: this.page,
          per: this.perPage,
          lat: this.latitude,
          lng: this.longitude,
          radius: this.radius,
        }
      }).then((response) => {
        this.vacancies = response.data.data.data
        this.responded = response.data.data.responded
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },

    inputCoordinates(lat, lng) {
      this.latitude = lat
      this.longitude = lng
    },
    clearCoordinates() {
      this.latitude = null
      this.longitude = null
    },

  }
}
</script>